/* tslint:disable */
/* eslint-disable */

/**
 * 1 = Fixe
 * 2 = Mobile
 */
export enum TypeConteneurValues {
  Fixe = 1,
  Mobile = 2
}
